import { Role, Permission, RolePermissions, roleHierarchy } from './types';

export const PERMISSIONS: RolePermissions = {
  read_only: new Set([]),
  member: new Set([
    "view:workspace:settings",
    "mutate:data",
    "use:ask_coffee:tools",
  ]),
  admin: new Set([
    "view:workspace:settings",
    "edit:workspace:settings",
    "manage:workspace:users",
    "manage:workspace:integrations",
    "manage:workspace:pipeline",
    "invite:user",
    "remove:user",
    "change:user:role",
    "mutate:data",
    "use:ask_coffee:tools",
  ]),
  owner: new Set([
    "view:workspace:settings",
    "edit:workspace:settings",
    "manage:workspace:users",
    "manage:workspace:integrations",
    "manage:workspace:pipeline",
    "manage:workspace:billing",
    "delete:workspace",
    "invite:user",
    "remove:user",
    "change:user:role",
    "mutate:data",
    "use:ask_coffee:tools",
  ]),
};

export const hasPermission = (role: Role, permission: Permission): boolean => {
  return PERMISSIONS[role]?.has(permission) ?? false;
};

export const canManageUser = (
  currentUserRole: Role,
  targetUserRole: Role
): boolean => {
  return roleHierarchy[currentUserRole] > roleHierarchy[targetUserRole];
};

export const canAssignRole = (
  currentUserRole: Role,
  targetRole: Role
): boolean => {
  return roleHierarchy[currentUserRole] >= roleHierarchy[targetRole];
};
